module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content video-add-content"
  }, [_c('div', {
    staticClass: "row video-add-body"
  }, [_vm._m(0), (_vm.error) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.error))])])]) : _vm._e(), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tên video *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameLesson),
      expression: "nameLesson"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Tên video",
      "required": "required",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.nameLesson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameLesson = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Danh mục bài học *")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "category",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'category')
      }
    }
  }, _vm._l((_vm.categLesson), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn môn học *")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "subject-id",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'subject')
      }
    }
  }, _vm._l((_vm.subjects), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id,
        "selected": o.id === _vm.subjectID
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "col-md-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn khối lớp *")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "grade",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'grade')
      }
    }
  }, _vm._l((_vm.grades), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "col-md-12 file-attach"
  }, [_vm._m(1), _c('div', {
    staticClass: "box-attach"
  }, [_c('div', {
    staticClass: "box-selected-file"
  }, [_c('input', {
    staticClass: "file",
    attrs: {
      "type": "file",
      "name": "videos[]",
      "accept": "video/*"
    },
    on: {
      "change": _vm.onVideoChange
    }
  }), _c('span', [_vm._v("Chọn video")]), _c('label', {
    staticClass: "files"
  }, [_vm._v("Cho phép file MP4, MOV")])]), _c('div', {
    staticClass: "box-items"
  }, _vm._l((_vm.lstVideos), function(item, index) {
    return (item) ? _c('div', {
      staticClass: "box-item-video"
    }, [_c('label', [_c('div', {
      staticClass: "title"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/theory/Mask Group 60.svg")
      }
    }), _c('span', [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "material-icons remove",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteVideo()
        }
      }
    }, [_vm._v("delete")])]), _c('div', [_c('video', {
      attrs: {
        "width": "240px",
        "controls": "controls",
        "src": item.src
      }
    })])])]) : _vm._e()
  }), 0), (_vm.lstVideos.length > 0) ? _c('div', {
    staticClass: "box-selected-thumbnail"
  }, [_c('input', {
    staticClass: "file",
    attrs: {
      "type": "file",
      "name": "thumbnail",
      "accept": "image/jpg"
    },
    on: {
      "change": _vm.onThumbnailChange
    }
  }), _c('span', [_vm._v("Chọn thumbnail")]), _c('label', {
    staticClass: "files"
  }, [_vm._v("Cho phép file jpg")])]) : _vm._e(), (_vm.lstVideos.length > 0) ? _c('div', {
    staticClass: "box-items"
  }, _vm._l((_vm.lstThumbnail), function(item, index) {
    return (item) ? _c('div', {
      staticClass: "box-item-thumbnail"
    }, [_c('span', {
      staticClass: "material-icons cancel",
      on: {
        "click": function($event) {
          return _vm.deleteThumbnail(index)
        }
      }
    }, [_vm._v("cancel")]), _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "height": "150px",
        "width": "auto"
      },
      attrs: {
        "src": item.src
      }
    })]) : _vm._e()
  }), 0) : _vm._e()])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "col-md-12 file-attach"
  }, [_c('div', {
    staticClass: "box-attach"
  }, [_c('div', {
    staticClass: "box-selected-file"
  }, [_c('input', {
    staticClass: "file",
    attrs: {
      "type": "file",
      "name": "files[]",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('span', [_vm._v("Chọn file")]), _c('label', {
    staticClass: "files"
  }, [_vm._v("Cho phép " + _vm._s(_vm.countFiles) + " files")])]), _c('div', {
    staticClass: "box-items"
  }, _vm._l((_vm.lstFiles), function(item, index) {
    return (item) ? _c('div', {
      staticClass: "box-item-attach"
    }, [_c('label', [_c('img', {
      staticClass: "fa-paperclip",
      attrs: {
        "src": require("../../assets/images/theory/Mask Group 55.svg")
      }
    }), _c('span', [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "material-icons remove",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_vm._v("delete")])])]) : _vm._e()
  }), 0)]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "col-md-12 content-large"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label text-md-right",
    attrs: {
      "for": "content"
    }
  }, [_vm._v("Nội dung")]), _c('froala', {
    attrs: {
      "tag": 'textarea',
      "config": _vm.config
    },
    on: {
      "input": function($event) {
        return _vm.changeContent($event)
      }
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "col-md-12 col-checkbox"
  }, [_c('div', {
    staticClass: "box-save"
  }, [_c('div', {
    staticClass: "title box-item-footer",
    style: (_vm.$isMobile() ? 'top: 0' : '')
  }, [_vm._v("LƯU VIDEO")]), (_vm.$isMobile()) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _c('div', {
    staticClass: "box-item-footer"
  }, [_c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "cb_question",
      "id": "cb_question"
    },
    on: {
      "click": function($event) {
        return _vm.onCheckSave($event, 3)
      }
    }
  }), _c('label', {
    attrs: {
      "for": "cb_question"
    }
  }), _c('span', [_vm._v("Lưu lại và chỉnh sửa sau")])])]), _c('div', {
    staticClass: "card card-save"
  }, [_c('div', {
    staticClass: "card-content card-content-save"
  }, [_c('div', {
    class: _vm.is_save_edit ? 'opacity' : ''
  }), _c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "public_all",
      "id": "public_all",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm.is_public === 2
    }
  }), _c('label', {
    attrs: {
      "for": "public_all"
    }
  }), _c('span', [_vm._v("Lưu video và cho phép học sinh trong toàn hệ thống tìm kiếm được để mua đáp án")])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "public_pc",
      "id": "public_pc"
    },
    on: {
      "click": function($event) {
        return _vm.onCheckSave($event, 2)
      }
    }
  }), _c('label', {
    attrs: {
      "for": "public_pc"
    }
  }), _c('span', [_vm._v("Lưu video riêng tư (chỉ cho hiển thị trong cộng đồng và lớp học của tôi)")])]), (_vm.is_public_pc > 1) ? _c('div', {
    staticClass: "box-left"
  }, [_c('div', {
    staticClass: "row row-share-class"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "class_id",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'class')
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "selected",
      "disabled": "disabled"
    }
  }, [_vm._v("Chọn lớp học bạn muốn chia sẻ trong PC")]), _vm._l((_vm.classes), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)])])]), _c('div', {
    staticClass: "row row-class"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.lstClassAdded), function(item, index) {
    return (item) ? _c('div', {
      staticClass: "box-item-attach"
    }, [_c('label', [_c('img', {
      attrs: {
        "src": require("../../assets/images/theory/ic_class.png")
      }
    }), _c('span', [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "material-icons remove",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteClass(index)
        }
      }
    }, [_vm._v("delete")])])]) : _vm._e()
  }), 0)])]) : _vm._e()])])]), _c('div', {
    staticClass: "button-handle"
  }, [_c('button', {
    staticClass: "btn btn-active",
    on: {
      "click": function($event) {
        return _vm.validateSave(1)
      }
    }
  }, [_vm._v("Thêm mới")]), _c('button', {
    staticClass: "btn btn-rest",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.validateSave(2)
      }
    }
  }, [_vm._v("Huỷ yêu cầu")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-md-header"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Thêm mới video")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach"
  }, [_c('strong', [_vm._v("File đính kèm")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b8d2188","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Videos/add_custom.vue
// module id = 1597
// module chunks = 0